import { useState, useEffect } from 'react';
import { createClient } from '@supabase/supabase-js';
import './App.css';

const supabaseUrl = 'https://qbdiatgqpbhhgtwsaekl.supabase.co';
const supabaseKey = 'sb_publishable_-YrF2NPCCEIcNTivy6gMdw_Kr5sH9zN';
const supabase = createClient(supabaseUrl, supabaseKey);

function App() {
  const [shoppingLists, setShoppingLists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchShoppingLists();
  }, []);

  const fetchShoppingLists = async () => {
    try {
      const { data } = await supabase
        .from('shopping_lists')
        .select(`
          *,
          shopping_list_items (
            id,
            ingredient_name,
            quantity,
            unit,
            have_at_home
          )
        `)
        .order('created_at', { ascending: false });
      
      setShoppingLists(data || []);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const generateShoppingList = async () => {
    try {
      const weeklyMenuId = '22222222-2222-2222-2222-222222222222';
      
      const response = await fetch('http://127.0.0.1:8787/api/shopping-list', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ weekly_menu_id: weeklyMenuId })
      });

      if (response.ok) {
        fetchShoppingLists();
        alert('✅ ¡Lista generada!');
      }
    } catch (error) {
      alert('❌ Error: ' + error.message);
    }
  };

  const toggleItem = async (listId, itemId) => {
    try {
      const { error } = await supabase
        .from('shopping_list_items')
        .update({ have_at_home: true })
        .eq('id', itemId)
        .eq('shopping_list_id', listId);
      
      if (!error) fetchShoppingLists();
    } catch (error) {
      console.error('Error:', error);
    }
  };

  if (loading) return <div>Cargando...</div>;

  return (
    <div className="App">
      <header>
        <h1>🍳 Mi Cocina</h1>
        <button onClick={generateShoppingList} className="btn-primary">
          🛒 Generar Lista Compra
        </button>
      </header>

      <div className="lists-container">
        {shoppingLists.length === 0 ? (
          <p>No hay listas. ¡Pulsa el botón para generar una!</p>
        ) : (
          shoppingLists.map(list => (
            <div key={list.id} className="shopping-list">
              <h3>Lista {new Date(list.created_at).toLocaleDateString()}</h3>
              <ul>
                {list.shopping_list_items.map(item => (
                  <li key={item.id} className={item.have_at_home ? 'checked' : ''}>
                    <label>
                      <input 
                        type="checkbox" 
                        checked={item.have_at_home}
                        onChange={() => toggleItem(list.id, item.id)}
                      />
                      <span>
                        <strong>{item.quantity} {item.unit}</strong> {item.ingredient_name}
                      </span>
                    </label>
                  </li>
                ))}
              </ul>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default App;